import React from 'react';

const TracesIcon = ({ size = 24, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Path/lines icon representing traces */}
      <polyline points="3 6 5 10 9 7 13 14 17 11 21 16" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
};

export default TracesIcon;

